import { cn } from "../../utils/cn";
import { useTheme, type ThemeName } from "./ThemeProvider";

const themeLabels: Record<ThemeName, string> = {
  defaulted: "Light",
  smoked: "Smoke",
  spectre: "Spectre",
  reel: "Reel"
};

export const ThemeSwitcher = ({ compact, className }: { compact?: boolean; className?: string }) => {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className={cn(
        "inline-flex shrink-0 items-center gap-0.5 rounded-full border border-border/70 bg-muted/80 p-0.5",
        compact ? "text-[11px]" : "text-xs",
        className
      )}
    >
      {(Object.keys(themeLabels) as ThemeName[]).map((key) => {
        const active = key === theme;
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setTheme(key)}
            className={cn(
              "whitespace-nowrap rounded-full px-2 py-0.5 font-medium transition-all",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/70 focus-visible:ring-offset-1 focus-visible:ring-offset-background",
              active
                ? "bg-card text-foreground shadow-subtle border border-border"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {themeLabels[key]}
          </button>
        );
      })}
    </div>
  );
};
